import React from 'react';

export type DefaultCardVariant =
  | 'transparent'
  | 'white'
  | 'blue'
  | 'blue-motif';

export type customDefaultCardProps = React.PropsWithoutRef<{
  className?: string;
  variant?: DefaultCardVariant;
  overlineLabel?: React.ReactNode;
  leftHeading?: string | React.ReactNode;
  leftSubheading?: string | React.ReactNode;
  rightHeading?: string;
  rightSubheading?: string | React.ReactNode;
  button?: React.ReactNode;
  secondButton?: React.ReactNode;
  image?: React.ReactNode;
  bottomLine?: string | React.ReactNode;
  isCurrentEvent?: boolean;
  closeButton?: React.ReactNode;
}>;

const getClassNameByVariant = (
  variant: DefaultCardVariant,
  className: string | undefined
) => {
  let wrapperClassName = 'default-card d-flex flex-column ';
  let bodyClassName = '';
  switch (variant) {
    case 'transparent': {
      wrapperClassName += 'transparent';
      break;
    }
    case 'white': {
      wrapperClassName += 'white';
      bodyClassName = 'one-column';
      break;
    }
    case 'blue': {
      wrapperClassName += 'blue';
      bodyClassName = 'one-column';

      break;
    }
    case 'blue-motif': {
      wrapperClassName += 'blue motif';
      bodyClassName = 'one-column';

      break;
    }
  }

  if (className) {
    wrapperClassName = [wrapperClassName, className].join(' ');
  }

  return { wrapperClassName, bodyClassName };
};

const DefaultCard = ({
  className,
  variant = 'transparent',
  overlineLabel,
  leftHeading,
  leftSubheading,
  rightHeading,
  rightSubheading,
  image,
  button,
  secondButton,
  bottomLine,
  isCurrentEvent = false,
  closeButton,
  ...props
}: customDefaultCardProps) => {
  const { wrapperClassName, bodyClassName } = getClassNameByVariant(
    variant,
    className
  );
  return (
    <div className={wrapperClassName}>
      <div className={`h-100 d-flex flex-column flex-lg-row ${bodyClassName} `}>
        <div
          className={`d-flex flex-row justify-content-between ${
            isCurrentEvent ? 'w-100' : ''
          }`}
        >
          <div
            className={`d-flex flex-column ${
              rightHeading ? 'card-text-group' : ''
            } ${isCurrentEvent ? 'w-100' : ''}`}
          >
            {overlineLabel && overlineLabel}
            <div className="card-heading left">{leftHeading}</div>
            {leftSubheading && (
              <div className="card-subheading">{leftSubheading}</div>
            )}
            {image && <div className="card-image">{image}</div>}
          </div>
          {variant === 'transparent' && (
            <div className="d-flex flex-column align-items-end card-text-group">
              <div className="card-heading right">{rightHeading}</div>
              {rightSubheading && (
                <div className="card-subheading right">{rightSubheading}</div>
              )}
            </div>
          )}
        </div>
        {(button || closeButton) && (
          <div className={`mb-0 d-flex ${closeButton ? 'flex-column' : 'flex-row'} justify-content-between align-items-end`}>
            {secondButton && (
              <div className="button-holder">{secondButton}</div>
            )}
            {closeButton && <div>{closeButton}</div>}
            {button && <div className="button-holder">{button}</div>}
          </div>
        )}
      </div>
      {bottomLine && <div className="mt-7">{bottomLine}</div>}
    </div>
  );
};

export default DefaultCard;
